import React from 'react'
import StatCard from '../../../../../components/widgets/StatCard'
import EditIcon from '@mui/icons-material/Edit';
import { Box, Grid } from '@mui/material';

const ProjectStatusBoard = ({ projectStatusData }) => {
    return (
        <Grid container spacing={2} marginTop={0.1}>
            <Grid item xs={12} sm={6} md={2.4}>
                <StatCard title="In Progress" number={projectStatusData?.inProgress} iconColor="#cac0e2" />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
                <StatCard title="Completed" number={projectStatusData?.completed} iconColor="#1dd75b" />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
                <StatCard title="OverDue" number={projectStatusData?.overdue} iconColor="#efb034" />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
                <StatCard title="Not Started" number={projectStatusData?.notStarted} iconColor="#dce1ea" />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
                <StatCard title="Hours Spent" number={projectStatusData?.hoursSpent} />
            </Grid>
        </Grid>
    )
}

export default ProjectStatusBoard